/**
 * Formats pesoKg value for display.
 * @param {number|null|undefined} pesoKg
 * @returns {string} — Formatted value with 2 decimal places, or dash for null/undefined
 */
export function formatPeso(pesoKg) {
  if (pesoKg == null) return "–";
  return pesoKg.toFixed(2);
}
